import graphql from "babel-plugin-relay/macro";
import { useAtomValue } from "jotai";
import { useCallback } from "react";

import { useFlags } from "@/utils/launchDarkly/useFlags";

import { useMutationWithError } from "../../../../../../../../utils/hooks/useMutationWithError";
import { updateLessonBookingPayloadAtom } from "../../../atoms/selectors/UpdatePayloads/updateLessonBookingPayload/updateLessonBookingPayloadAtom";
import { currentSessionMemberShipTypeIdAtom } from "../../../atoms/stores";
import { useSaveChangesToLessonBookingMutation } from "./__generated__/useSaveChangesToLessonBookingMutation.graphql";

export const useSaveChangesToLessonBooking = (successCallback: () => void) => {
  const updateLessonBookingPayload = useAtomValue(
    updateLessonBookingPayloadAtom
  );
  const { patronLoyalty } = useFlags();

  const [saveChangesToLessonBooking, isSavingChanges] =
    useMutationWithError<useSaveChangesToLessonBookingMutation>(
      useSaveChangesToLessonBookingString
    );
  const membershipTypeId = useAtomValue(currentSessionMemberShipTypeIdAtom);
  const handleSaveLessonBooking = useCallback(() => {
    if (!updateLessonBookingPayload) return;
    saveChangesToLessonBooking({
      variables: {
        input: updateLessonBookingPayload,
        membershipTypeId: membershipTypeId ?? "",
        bookingType: "LESSON",
        patronLoyalty: !!patronLoyalty,
      },
      onCompleted: (data) => {
        successCallback();
      },
    });
  }, [
    saveChangesToLessonBooking,
    successCallback,
    updateLessonBookingPayload,
    membershipTypeId,
    patronLoyalty,
  ]);

  return [handleSaveLessonBooking, isSavingChanges] as const;
};
const useSaveChangesToLessonBookingString = graphql`
  mutation useSaveChangesToLessonBookingMutation(
    $input: UpdateLessonBookingInput!
    $membershipTypeId: ID!
    $bookingType: BookingType!
    $patronLoyalty: Boolean!
  ) {
    responsePayload: updateLessonBooking(input: $input) {
      errors {
        code

        message
        field
      }
      success
      booking {
        ...BookingSummary_booking @arguments(patronLoyalty: $patronLoyalty)
      }
    }
  }
`;
